import { apiGET, apiPOST, apiDELETE } from './api';

export const getCalendarStatus = userId => {
  return apiGET(`/users/${userId}/google-calendar/status`);
};

export const getCalendarAuthUrl = (userId, redirectUrl) => {
  const encodedRedirectUrl = encodeURIComponent(redirectUrl);
  return apiGET(`/users/${userId}/google-calendar/auth-url?redirect_url=${encodedRedirectUrl}`);
};

export const addRescueToCalendar = (userId, rescueId) => {
  return apiPOST(`/users/${userId}/rescues/${rescueId}/google-calendar`);
};

export const removeRescueFromCalendar = (userId, rescueId) => {
  return apiDELETE(`/users/${userId}/rescues/${rescueId}/google-calendar`);
};
